/**
 * Page translation mapping - maps a slug in any language to its translations
 * Client-safe module (no Node.js imports) for use in language-switcher
 */
export const pageTranslations: Record<string, Record<string, string>> = {
  // About
  'over-ons': { nl: 'over-ons', en: 'about', de: 'ueber-uns', fr: 'a-propos' },
  'about': { nl: 'over-ons', en: 'about', de: 'ueber-uns', fr: 'a-propos' },
  'ueber-uns': { nl: 'over-ons', en: 'about', de: 'ueber-uns', fr: 'a-propos' },
  'a-propos': { nl: 'over-ons', en: 'about', de: 'ueber-uns', fr: 'a-propos' },

  // Analytics
  'analyse': { nl: 'analyse', en: 'analytics', de: 'analytik', fr: 'analytique' },
  'analytics': { nl: 'analyse', en: 'analytics', de: 'analytik', fr: 'analytique' },
  'analytik': { nl: 'analyse', en: 'analytics', de: 'analytik', fr: 'analytique' },
  'analytique': { nl: 'analyse', en: 'analytics', de: 'analytik', fr: 'analytique' },

  // Auth
  'verificatie': { nl: 'verificatie', en: 'auth', de: 'authentifizierung', fr: 'authentification' },
  'auth': { nl: 'verificatie', en: 'auth', de: 'authentifizierung', fr: 'authentification' },
  'authentifizierung': { nl: 'verificatie', en: 'auth', de: 'authentifizierung', fr: 'authentification' },
  'authentification': { nl: 'verificatie', en: 'auth', de: 'authentifizierung', fr: 'authentification' },

  // Cancellation Policy
  'annuleringsbeleid': { nl: 'annuleringsbeleid', en: 'cancellation-policy', de: 'widerrufsrecht', fr: 'politique-annulation' },
  'cancellation-policy': { nl: 'annuleringsbeleid', en: 'cancellation-policy', de: 'widerrufsrecht', fr: 'politique-annulation' },
  'widerrufsrecht': { nl: 'annuleringsbeleid', en: 'cancellation-policy', de: 'widerrufsrecht', fr: 'politique-annulation' },
  'politique-annulation': { nl: 'annuleringsbeleid', en: 'cancellation-policy', de: 'widerrufsrecht', fr: 'politique-annulation' },

  // Companies
  'bedrijven': { nl: 'bedrijven', en: 'companies', de: 'unternehmen', fr: 'entreprises' },
  'companies': { nl: 'bedrijven', en: 'companies', de: 'unternehmen', fr: 'entreprises' },
  'unternehmen': { nl: 'bedrijven', en: 'companies', de: 'unternehmen', fr: 'entreprises' },
  'entreprises': { nl: 'bedrijven', en: 'companies', de: 'unternehmen', fr: 'entreprises' },

  // Credit Notes
  'creditnotas': { nl: 'creditnotas', en: 'credit-notes', de: 'gutschriften', fr: 'avoirs' },
  'credit-notes': { nl: 'creditnotas', en: 'credit-notes', de: 'gutschriften', fr: 'avoirs' },
  'gutschriften': { nl: 'creditnotas', en: 'credit-notes', de: 'gutschriften', fr: 'avoirs' },
  'avoirs': { nl: 'creditnotas', en: 'credit-notes', de: 'gutschriften', fr: 'avoirs' },

  // Customers
  'klanten': { nl: 'klanten', en: 'customers', de: 'kunden', fr: 'clients' },
  'customers': { nl: 'klanten', en: 'customers', de: 'kunden', fr: 'clients' },
  'kunden': { nl: 'klanten', en: 'customers', de: 'kunden', fr: 'clients' },
  'clients': { nl: 'klanten', en: 'customers', de: 'kunden', fr: 'clients' },

  // Dashboard
  'dashboard': { nl: 'dashboard', en: 'dashboard', de: 'dashboard', fr: 'tableau-de-bord' },
  'tableau-de-bord': { nl: 'dashboard', en: 'dashboard', de: 'dashboard', fr: 'tableau-de-bord' },

  // Invoices
  'facturen': { nl: 'facturen', en: 'invoices', de: 'rechnungen', fr: 'factures' },
  'invoices': { nl: 'facturen', en: 'invoices', de: 'rechnungen', fr: 'factures' },
  'rechnungen': { nl: 'facturen', en: 'invoices', de: 'rechnungen', fr: 'factures' },
  'factures': { nl: 'facturen', en: 'invoices', de: 'rechnungen', fr: 'factures' },

  // Language
  'taal': { nl: 'taal', en: 'language', de: 'sprache', fr: 'langue' },
  'language': { nl: 'taal', en: 'language', de: 'sprache', fr: 'langue' },
  'sprache': { nl: 'taal', en: 'language', de: 'sprache', fr: 'langue' },
  'langue': { nl: 'taal', en: 'language', de: 'sprache', fr: 'langue' },

  // Modules
  'modules': { nl: 'modules', en: 'modules', de: 'module', fr: 'modules' },
  'module': { nl: 'modules', en: 'modules', de: 'module', fr: 'modules' },

  // Orders
  'bestellingen': { nl: 'bestellingen', en: 'orders', de: 'bestellungen', fr: 'commandes' },
  'orders': { nl: 'bestellingen', en: 'orders', de: 'bestellungen', fr: 'commandes' },
  'bestellungen': { nl: 'bestellingen', en: 'orders', de: 'bestellungen', fr: 'commandes' },
  'commandes': { nl: 'bestellingen', en: 'orders', de: 'bestellungen', fr: 'commandes' },

  // PDF Templates
  'pdf-sjablonen': { nl: 'pdf-sjablonen', en: 'pdf-templates', de: 'pdf-vorlagen', fr: 'modeles-pdf' },
  'pdf-templates': { nl: 'pdf-sjablonen', en: 'pdf-templates', de: 'pdf-vorlagen', fr: 'modeles-pdf' },
  'pdf-vorlagen': { nl: 'pdf-sjablonen', en: 'pdf-templates', de: 'pdf-vorlagen', fr: 'modeles-pdf' },
  'modeles-pdf': { nl: 'pdf-sjablonen', en: 'pdf-templates', de: 'pdf-vorlagen', fr: 'modeles-pdf' },

  // Platforms
  'platformen': { nl: 'platformen', en: 'platforms', de: 'plattformen', fr: 'plateformes' },
  'platforms': { nl: 'platformen', en: 'platforms', de: 'plattformen', fr: 'plateformes' },
  'plattformen': { nl: 'platformen', en: 'platforms', de: 'plattformen', fr: 'plateformes' },
  'plateformes': { nl: 'platformen', en: 'platforms', de: 'plattformen', fr: 'plateformes' },

  // Privacy
  'privacy': { nl: 'privacy', en: 'privacy', de: 'datenschutz', fr: 'confidentialite' },
  'datenschutz': { nl: 'privacy', en: 'privacy', de: 'datenschutz', fr: 'confidentialite' },
  'confidentialite': { nl: 'privacy', en: 'privacy', de: 'datenschutz', fr: 'confidentialite' },

  // Cookie Policy
  'cookiebeleid': { nl: 'cookiebeleid', en: 'cookie-policy', de: 'cookie-richtlinie', fr: 'politique-cookies' },
  'cookie-policy': { nl: 'cookiebeleid', en: 'cookie-policy', de: 'cookie-richtlinie', fr: 'politique-cookies' },
  'cookie-richtlinie': { nl: 'cookiebeleid', en: 'cookie-policy', de: 'cookie-richtlinie', fr: 'politique-cookies' },
  'politique-cookies': { nl: 'cookiebeleid', en: 'cookie-policy', de: 'cookie-richtlinie', fr: 'politique-cookies' },

  // Providers
  'aanbieders': { nl: 'aanbieders', en: 'providers', de: 'anbieter', fr: 'fournisseurs' },
  'providers': { nl: 'aanbieders', en: 'providers', de: 'anbieter', fr: 'fournisseurs' },
  'anbieter': { nl: 'aanbieders', en: 'providers', de: 'anbieter', fr: 'fournisseurs' },
  'fournisseurs': { nl: 'aanbieders', en: 'providers', de: 'anbieter', fr: 'fournisseurs' },

  // Refund Policy
  'retourbeleid': { nl: 'retourbeleid', en: 'refund-policy', de: 'rueckgaberecht', fr: 'politique-remboursement' },
  'refund-policy': { nl: 'retourbeleid', en: 'refund-policy', de: 'rueckgaberecht', fr: 'politique-remboursement' },
  'rueckgaberecht': { nl: 'retourbeleid', en: 'refund-policy', de: 'rueckgaberecht', fr: 'politique-remboursement' },
  'politique-remboursement': { nl: 'retourbeleid', en: 'refund-policy', de: 'rueckgaberecht', fr: 'politique-remboursement' },

  // Stores
  'winkels': { nl: 'winkels', en: 'stores', de: 'shops', fr: 'magasins' },
  'stores': { nl: 'winkels', en: 'stores', de: 'shops', fr: 'magasins' },
  'shops': { nl: 'winkels', en: 'stores', de: 'shops', fr: 'magasins' },
  'magasins': { nl: 'winkels', en: 'stores', de: 'shops', fr: 'magasins' },

  // Subscriptions
  'abonnementen': { nl: 'abonnementen', en: 'subscriptions', de: 'abonnements', fr: 'abonnements' },
  'subscriptions': { nl: 'abonnementen', en: 'subscriptions', de: 'abonnements', fr: 'abonnements' },
  'abonnements': { nl: 'abonnementen', en: 'subscriptions', de: 'abonnements', fr: 'abonnements' },

  // UBL Export (same in all languages)
  'ubl-export': { nl: 'ubl-export', en: 'ubl-export', de: 'ubl-export', fr: 'ubl-export' },

  // Terms / Voorwaarden
  'voorwaarden': { nl: 'voorwaarden', en: 'terms', de: 'agb', fr: 'conditions-generales' },
  'terms': { nl: 'voorwaarden', en: 'terms', de: 'agb', fr: 'conditions-generales' },
  'agb': { nl: 'voorwaarden', en: 'terms', de: 'agb', fr: 'conditions-generales' },
  'conditions-generales': { nl: 'voorwaarden', en: 'terms', de: 'agb', fr: 'conditions-generales' },
};
